

function ShowLogbookFullText(text) {

    console.log("here");
    console.log(text);

    if (text != null) {
        try {
            text = text.replace(/&quot;/g, '\"');
        } catch (e) {

        }
        //text = text.replaceAll("&quot;", "\"");
    }

    swal({
        title: "",
        text: text,
        customClass: 'swal-wide-column-tips'
    });
}

function confirmClearLogbook(logbookId) {

    swal({
        title: "Are you sure?",
        text: " ",
        showCancelButton: true,
        confirmButtonText: "Yes, cancel.",
        cancelButtonText: "No",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnClearLogbookConfirmed', logbookId);
        });
}



function InitOperationResidentSpecificLogbookTypeahead(people) {

    var peopleRaw = [];

    var count = people.length;
    for (var i = 0; i < count; i++) {
        var name = people[i].receiverName;
        var unit = people[i].receiverUnit;
        if (name !== "") {
            peopleRaw.push(unit + ", " + name);
        }
    }

    buildTypeahead('#logbookReceiverSelect .typeahead', "people", peopleRaw);

    return true;
}

function SetResidentSpecificCheckboxToFalse(arg) {
    $('#residentSpecificSwitch').prop('checked', false);
}



function logbookSentSuccess(arg) {
    swal({
        title: "Sent",
        text: "Logbook sent",
        type: "success",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1500
    });

}


